import { parsePhoneNumberFromString } from 'libphonenumber-js'

export const normalizePhoneNumber = (phoneNumber: string): string | null => {
    const phone = parsePhoneNumberFromString(phoneNumber, 'FI')
    if (phone && phone.isValid()) {
      return phone.formatInternational();
    }
    return null;
}